import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment-timezone';

@Pipe({
    name: 'timeLeft',
    standalone: false
})
export class TimeLeftPipe implements PipeTransform {

  constructor(private readonly translateService: TranslateService) { }

  transform(value: Date, timezone = null): string {
    if (!value) {
      return '';
    }

    let date = new Date(value);

    if (timezone) {
      date = moment(value).utc(false).tz(timezone, true).toDate();
    }

    const now = new Date();
    const diffTime = Math.abs(now.getTime() - date.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) - 1;

    if (diffDays === 0) {
      const diffMinutes = Math.ceil(diffTime / (1000 * 60));

      if (diffMinutes < 60) {
        return this.translateService.instant('COMMON.minutes_left', { minutes: diffMinutes })
      }

      const diffHours = Math.floor(diffMinutes / 60);
      return this.translateService.instant('COMMON.hours_left', { hours: diffHours });
    }

    return this.translateService.instant('COMMON.days_left', { days: diffDays });
  }
}
